import axios from "./axios-client";

export async function getAll(params: any): Promise<any> {
  const response = await axios({
    method: "GET",
    url: `/notification/`,
    params: params,
  });
  return response.data;
}

export async function uploadType(data: any): Promise<any> {
  const response = await axios({
    method: "PUT",
    url: `/notification/`,
    data: data,
  });
  return response.data;
}

export async function readAll(): Promise<any> {
  const response = await axios({
    method: "POST",
    url: `/notification/readAll`,
  });
  return response.data;
}



export default {
  getAll,
  uploadType,
  readAll
};
